import { cn } from "@repo/ui/lib/cn";

/**
 * Border, fill, text, and hover tokens for the marketing banner dismiss control.
 * Reused by SaaS header chrome (burger, breadcrumb nav dropdown trigger).
 */
export const BANNER_DISMISS_CHROME_SURFACE_CLASS = cn(
	"border border-border/60 bg-background/90 text-muted-foreground shadow-sm",
	"hover:bg-muted/80 hover:text-foreground",
	"dark:border-white/15 dark:bg-gray-900/90 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white",
);

/** Circular icon button using {@link BANNER_DISMISS_CHROME_SURFACE_CLASS}. */
export const BANNER_DISMISS_ICON_BUTTON_CLASS = cn(
	"flex shrink-0 cursor-pointer items-center justify-center rounded-full",
	BANNER_DISMISS_CHROME_SURFACE_CLASS,
);
